var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('h1',[_vm._v("Vos slimes")]),_c('h5',[_vm._v("Cette onglet reprend l'univers du jeu Slime Rancher")]),_c('slime-blocks')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }